import AService from '@/services/AService'

const ENTITY_NAME = 'users';

export default class UserService extends AService {
  async getCurrentUser() {
    const response = await this.http.get(`${this.baseUrl}/${ENTITY_NAME}/current`)
    return response.data
  }

  async activateUser(activationCode) {
    const response = await this.http.get(`${this.baseUrl}/${ENTITY_NAME}/activate?activationCode=${activationCode}`)
    return response.data
  }

  async registerUser(data) {
    const response = await this.http.post(`${this.baseUrl}/${ENTITY_NAME}/register`, data);
    return response.data;
  }

  async createUser(data) {
    const response = await this.http.post(`${this.baseUrl}/${ENTITY_NAME}`, data);
    return response.data;
  }

  async addUserByAgent(data) {
    const response = await this.http.post(`${this.baseUrl}/${ENTITY_NAME}/agent`, data);
    return response.data;
  }

  async resendActivationCode(userId) {
    const response = await this.http.get(`${this.baseUrl}/${ENTITY_NAME}/resendActivationCode?userId=${userId}`)
    return response.data;
  }

  async updateUser(data) {
    const response = await this.http.put(`${this.baseUrl}/${ENTITY_NAME}`, data);
    return response.data
  }

  async getUser(id) {
    const response = await this.http.get(`${this.baseUrl}/${ENTITY_NAME}/${id}`);
    return response.data;
  }

  async fetchUser(userId) {
    const response = await this.http.get(`${this.baseUrl}/${ENTITY_NAME}/${userId}`)
    return response.data
  }

  async resetPassword(email) {
    try {
      const response = await this.http.post(`${this.baseUrl}/${ENTITY_NAME}/resetPassword`, email, {headers: {'Content-Type': 'text/plain'}});
      return response.data;
    } catch (e) {
      throw e.response.data;
    }
  }

  async changePassword(body) {
    try {
      const response = await this.http.post(`${this.baseUrl}/${ENTITY_NAME}/changePassword`, body)
      return response.data
    } catch (e) {
      throw e.response.data;
    }
  }

  async isValid(token) {
    const response = await this.http.post(`${this.baseUrl}/${ENTITY_NAME}/isValid`, token, {headers: {'Content-Type': 'text/plain'}})
    return response.data;
  }

  async fetchUsersPagingAndSorting(params) {
    const response = await this.http.get(`${this.baseUrl}/${ENTITY_NAME}/pagingAndSorting`, {params})
    return response.data;
  }

  async unlockUserByAdmin(id) {
    const response = await this.http.post(`${this.baseUrl}/${ENTITY_NAME}/unlock/${id}`);
    return response.data
  }

  async lockUser(id) {
    const response = await this.http.post(`${this.baseUrl}/${ENTITY_NAME}/lock/${id}`);
    return response.data
  }

  async deleteUser(id) {
    const response = await this.http.delete(`${this.baseUrl}/${ENTITY_NAME}/${id}`)
    return response.data
  }

  async approveUser(approvalUser) {
    const response = await this.http.post(`${this.baseUrl}/${ENTITY_NAME}/approve`, approvalUser)
    return response.data
  }
}
